module.exports = __webpack_public_path__ + "assets/images/2df86d42469e49967ce0012015712223.png";